import {
  ADD_PRE_ASSESSMENT_DATA,
  ADD_PRE_ASSESSMENT_DATA_FAILURE,
  ADD_PRE_ASSESSMENT_DATA_SUCCESS,
  FETCH_PRE_ASSESSMENT_DATA,
  FETCH_PRE_ASSESSMENT_DATA_FAILURE,
  FETCH_PRE_ASSESSMENT_DATA_SUCCESS,
  FETCH_PRE_ASSESSMENT_VIDEO,
  FETCH_PRE_ASSESSMENT_VIDEO_FAILURE,
  FETCH_PRE_ASSESSMENT_VIDEO_SUCCESS,
  ATTEMPT_FAIL_PRE_ASSESSMENT,
  ATTEMPT_FAIL_PRE_ASSESSMENT_SUCCESS,
  ATTEMPT_FAIL_PRE_ASSESSMENT_FAILURE,
  RESET_ADD_PRE_ASSESSMENT_DATA,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC_SUCCESS,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC_FAILURE,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL_SUCCESS,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL_FAILURE,
  RESET_PRE_ASSESSMENT_DATA_VIDEO,
  RESET_PRE_ASSESSMENT_DATA,
  RESET_PRE_ASSESSMENT_VIDEO,
} from "./actionTypes";

const initialState = {
  preAssessment: null,
  error: null,
  loading: false,
  success: false,
  preAssessmentVideo: null,
  preAssessmentVideoError: null,
  preAssessmentVideoLoading: false,
  PreAssessmentData: {},
  PreAssessmentDataError: null,
  PreAssessmentDataLoading: false,
  preAssessmentToken: null,
  PreAssessmentDataPublic: {},
  PreAssessmentDataPublicError: null,
  PreAssessmentDataPublicLoading: false,
};

const PreAssessmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRE_ASSESSMENT_DATA:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case ADD_PRE_ASSESSMENT_DATA_SUCCESS:
      return {
        ...state,
        preAssessment: action.payload,
        loading: false,
        success: true,
      };

    case ADD_PRE_ASSESSMENT_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      };
    case FETCH_PRE_ASSESSMENT_VIDEO:
      return {
        ...state,
        preAssessmentVideoLoading: true,
        preAssessmentVideoError: null,
      };

    case FETCH_PRE_ASSESSMENT_VIDEO_SUCCESS:
      return {
        ...state,
        preAssessmentVideo: action.payload,
        preAssessmentVideoLoading: false,
      };
    case FETCH_PRE_ASSESSMENT_VIDEO_FAILURE:
      return {
        ...state,
        preAssessmentVideoError: action.payload,
        preAssessmentVideoLoading: false,
      };
    case FETCH_PRE_ASSESSMENT_DATA:
      return {
        ...state,
        PreAssessmentDataLoading: true,
        PreAssessmentDataError: null,
      };
    case FETCH_PRE_ASSESSMENT_DATA_SUCCESS:
      return {
        ...state,
        PreAssessmentData: action.payload,
        PreAssessmentDataLoading: false,
      };
    case FETCH_PRE_ASSESSMENT_DATA_FAILURE:
      return {
        ...state,
        PreAssessmentDataError: action.payload,
        PreAssessmentDataLoading: false,
      };
    case ATTEMPT_FAIL_PRE_ASSESSMENT:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case ATTEMPT_FAIL_PRE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        preAssessmentToken: action.payload,
        loading: false,
        success: true,
      };
    case ATTEMPT_FAIL_PRE_ASSESSMENT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      };
    case RESET_ADD_PRE_ASSESSMENT_DATA:
      return {
        ...state,
        error: null,
        loading: false,
        success: false,
      };
    case FETCH_PRE_ASSESSMENT_DATA_PUBLIC:
      return {
        ...state,
        PreAssessmentDataPublicLoading: true,
        PreAssessmentDataPublicError: null,
      };
    case FETCH_PRE_ASSESSMENT_DATA_PUBLIC_SUCCESS:
      return {
        ...state,
        PreAssessmentDataPublic: action.payload,
        PreAssessmentDataPublicLoading: false,
      };
    case FETCH_PRE_ASSESSMENT_DATA_PUBLIC_FAILURE:
      return {
        ...state,
        PreAssessmentDataPublicError: action.payload,
        PreAssessmentDataPublicLoading: false,
      };
    case RESET_PRE_ASSESSMENT_DATA_VIDEO:
      return {
        ...state,
        preAssessmentVideo: null,
        preAssessmentVideoError: null,
        preAssessmentVideoLoading: false,
        PreAssessmentData: {},
        PreAssessmentDataError: null,
        PreAssessmentDataLoading: false,
      };
    case RESET_PRE_ASSESSMENT_DATA:
      return {
        ...state,
        PreAssessmentData: {},
        error: null,
        loading: false,
        success: false,
      };
    case RESET_PRE_ASSESSMENT_VIDEO:
      return {
        ...state,
        preAssessmentVideo: null,
        error: null,
        loading: false,
        success: false,
      };
    default:
      return state;
  }
};

export default PreAssessmentReducer;
